<template>
    <div>
        <merus-data-table
            :headers="headers"
            :items="linhas"
            :mostrar-inativos="mostrarInativos"
            :loading="loadingtable"
            :loading-text="$t('CRUDVigencia.loading')"
            :default-multi-sort="defaultSort"
            :server-items-length="totalLinhas"
            :items-per-page="numberOfRows"
            :items-per-page-last-option="itemsPerPageLastOption"
            :server-sort-by="serverSortBy"
            :server-sort-desc="serverSortDesc"
            @update:options="onTableOptions"
            @update:filters="onFiltersUpdate"
            item-key="id_linha"
            :hide-sort-button="true"
cod-tabela="VIGENCIA" @update:headers="headers = $event">
            <template v-slot:toolbar>
                <cadastro-toolbar
                    :title="$t('CRUDVigencia.title')"
                    :token="token"
                    :items="linhas"
                    hide-search
                >
                    <template v-slot:extension>
                        <v-switch
                            v-model="mostrarInativos"
                            :label="$t('crudVeiculos.showInactive')"
                            class="ml-3 mr-4"
                            hide-details
                        ></v-switch>
                    </template>
                </cadastro-toolbar>
            </template>

            <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" color="blue" @click="viewLinha(item)">mdi-pencil</v-icon>
            </template>
        </merus-data-table>

        <!-- Dialog para Rotas e Cercas -->
        <v-dialog v-model="dialog" persistent fullscreen>
            <v-card>
                <v-toolbar color="primary" dark flat>
                    <v-toolbar-title v-if="selectedLinha">
                        {{ selectedLinha.nome_linha }} - {{ selectedLinha.cod_linha }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="fechaDialogo">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text>
                    <v-tabs v-model="tab" align-with-title>
                        <v-tab>{{ $t('CRUDVigencia.routes.title') }}</v-tab>
                        <v-tab>{{ $tc('CRUDVigencia.fences.title', 2) }}</v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tab">
                        <!-- Inicio Rotas -->
                        <v-tab-item>
                            <v-row>
                                <v-col>
                                    <div style="display: flex; flex-flow: column; margin-left: 20px;">
                                        <h3 class="mt-4 mb-3">{{ $t('CRUDVigencia.routes.standard') }}</h3>
                                        <p class="text-subtitle-2 grey--text mb-3">{{ $t('CRUDVigencia.routes.subtitle') }}</p>
                                    </div>
                                </v-col>
                                <v-col style="display: flex; justify-content: center; align-items: center;" >
                                    <v-btn color="primary" @click="openAddRotaVigenciaDialog" style="display: flex;margin: auto;">
                                        <v-icon left>mdi-plus</v-icon>
                                        {{ $t('CRUDVigencia.routes.addAlternative') }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <merus-data-table :headers="rotasHeadersWithActions" :items="rotas" item-key="id_rota" :hide-sort-button="true"

 cod-tabela="VIGENCIA_ROTASHEADERSWITHACTIONS" @update:headers="rotasHeadersWithActions = $event">
                                <template v-slot:item.actions="{ item }">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon small color="primary" @click="selectRotaForVigencia(item)"
                                                v-bind="attrs" v-on="on"
                                                :outlined="selectedRotaForVigencia && selectedRotaForVigencia.id_rota === item.id_rota">
                                                <v-icon small>{{ selectedRotaForVigencia &&
                                                    selectedRotaForVigencia.id_rota === item.id_rota ?
                                                    'mdi-check-circle' : 'mdi-eye' }}</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{ selectedRotaForVigencia && selectedRotaForVigencia.id_rota ===
                                            item.id_rota ?
                                            $t('CRUDVigencia.routes.selected') : $t('CRUDVigencia.routes.viewAlternatives') }}</span>
                                    </v-tooltip>
                                </template>
                            </merus-data-table>

                            <v-divider class="my-6" v-if="selectedRotaForVigencia"></v-divider>

                            <div v-if="selectedRotaForVigencia">
                                <div class="d-flex align-center mb-3">
                                    <h3>{{ $t('CRUDVigencia.routes.alternativesTitle', { name: selectedRotaForVigencia.nome_rota }) }}</h3>
                                    <v-spacer></v-spacer>
                                </div>
                                <merus-data-table :headers="rotasVigenciaHeaders" :items="filteredRotasVigencia"

 cod-tabela="VIGENCIA_ROTAS_VIGENCIA" @update:headers="rotasVigenciaHeaders = $event">
                                    <template v-slot:item.nome_rota_substituida="{ item }">
                                        {{ item.nome_rota_substituida || '-' }}
                                    </template>
                                    <template v-slot:item.data_inicio="{ item }">
                                        {{ formatDate(item.data_inicio) }}
                                    </template>
                                    <template v-slot:item.data_final="{ item }">
                                        {{ formatDate(item.data_final) }}
                                    </template>
                                    <template v-slot:item.ativo="{ item }">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-checkbox v-model="item.ativo_linhas_rotas" :true-value="1" :false-value="0"
                                                    color="primary" dense hide-details disabled readonly v-bind="attrs"
                                                    v-on="on" style="pointer-events: none;"></v-checkbox>
                                            </template>
                                            <span>{{ $t('CRUDVigencia.routes.statusTableLinesRoutes') }}</span>
                                        </v-tooltip>
                                    </template>
                                    <template v-slot:item.actions="{ item }">
                                        <v-icon small class="mr-2" color="green" @click="editRotaVigencia(item)">
                                            mdi-pencil
                                        </v-icon>
                                        <v-icon small color="red" @click="deleteRotaVigencia(item)">
                                            mdi-delete
                                        </v-icon>
                                    </template>
                                </merus-data-table>
                            </div>
                        </v-tab-item>
                        <!-- Inicio Cercas -->
                        <v-tab-item>
                            <!-- Section 1: Cercas Padrão (Default Stops) -->
                            <v-card flat class="mb-0">
                                <v-card-title>
                                    <v-icon left dark>mdi-map-marker-multiple</v-icon>
                                    {{ $t('CRUDVigencia.fences.standard') }}
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary" @click="openAddCercaVigenciaDialog">
                                        <v-icon left>mdi-plus</v-icon>
                                        {{ $t('CRUDVigencia.fences.addAlternative') }}
                                    </v-btn>
                                </v-card-title>
                                <v-card-subtitle class="pt-2">
                                    {{ $t('CRUDVigencia.fences.subtitle') }}
                                </v-card-subtitle>
                                <v-card-text>
                                    <merus-data-table
                                        :headers="cercasHeadersExpanded"
                                        :items="cercas"

 cod-tabela="VIGENCIA_CERCASHEADERSEXPANDED" @update:headers="cercasHeadersExpanded = $event">
                                    </merus-data-table>
                                </v-card-text>
                            </v-card>

                            <!-- Section 3: Cercas Alternativas -->
                            <v-card flat class="mb-0">
                                <v-card-title class="darken-1">
                                    <v-icon left dark>mdi-map-marker-path</v-icon>
                                    {{ $t('CRUDVigencia.fences.alternativesTitle') }}
                                </v-card-title>
                                <v-card-subtitle class="pt-2">
                                    {{ $t('CRUDVigencia.fences.alternativesSubtitle') }}
                                </v-card-subtitle>
                                <v-card-text>
                                    <merus-data-table :headers="cercasVigenciaHeaders" :items="cercasVigenciaGrouped"

 cod-tabela="VIGENCIA_CERCAS_VIGENCIA" @update:headers="cercasVigenciaHeaders = $event">
                                        <template v-slot:item.data_inicio="{ item }">
                                            {{ formatDate(item.data_inicio) }}
                                        </template>
                                        <template v-slot:item.data_fim="{ item }">
                                            {{ formatDate(item.data_fim) }}
                                        </template>
                                        <template v-slot:item.actions="{ item }">
                                            <v-icon small class="mr-2" color="blue" @click="selectVigenciaToViewStops(item)">
                                                mdi-eye
                                            </v-icon>
                                            <v-icon small class="mr-2" color="green" @click="editCercaVigencia(item)">
                                                mdi-pencil
                                            </v-icon>
                                            <v-icon small color="red" @click="deleteCercaVigencia(item)">
                                                mdi-delete
                                            </v-icon>
                                        </template>
                                    </merus-data-table>
                                </v-card-text>
                            </v-card>

                            <!-- Section 4: Stops in Selected Vigência -->
                            <v-card flat class="mb-0" v-if="selectedVigencia">
                                <v-card-title class="darken-1">
                                    <v-icon left dark>mdi-format-list-bulleted-square</v-icon>
                                    {{ $t('CRUDVigencia.fences.stopsTitle', { id: selectedVigencia.id_associacao }) }}
                                </v-card-title>
                                <v-card-subtitle class="pt-2">
                                    {{ $t('CRUDVigencia.fences.stopsSubtitle') }}
                                </v-card-subtitle>
                                <v-card-text>
                                    <merus-data-table
                                        :headers="stopsInVigenciaHeaders"
                                        :items="stopsInSelectedVigencia"

 cod-tabela="VIGENCIA_STOPS_IN_VIGENCIA" @update:headers="stopsInVigenciaHeaders = $event">
                                    </merus-data-table>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Dialog para Adicionar/Editar Rota Vigência -->
        <v-dialog v-model="dialogRotaVigencia" max-width="600px" persistent>
            <v-card>
                <v-card-title>
                    <span class="text-h5">
                        {{ isEditingRotaVigencia ? $t('CRUDVigencia.routes.editAlternative') : $t('CRUDVigencia.routes.addAlternative') }} {{ $t('CRUDVigencia.routes.alternative') }}
                    </span>
                </v-card-title>

                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-select v-model="editedRotaVigencia.id_rota" :items="allRotas" item-text="nome_rota"
                                    item-value="id_rota" :label="$t('CRUDVigencia.routes.routeAlternative')" required>
                                    <template v-slot:selection="{ item }">
                                        {{ item.cod_rota }} - {{ item.nome_rota }}
                                    </template>
                                    <template v-slot:item="{ item }">
                                        {{ item.cod_rota }} - {{ item.nome_rota }}
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-select v-model="editedRotaVigencia.id_rota_substituida" :items="rotas"
                                    item-text="nome_rota" item-value="id_rota" :label="$t('CRUDVigencia.routes.routeSubstituted')"
                                    required readonly disabled :hint="$t('CRUDVigencia.routes.routeSubstitutedHint')"
                                    persistent-hint>
                                    <template v-slot:selection="{ item }">
                                        {{ item.cod_rota }} - {{ item.nome_rota }}
                                    </template>
                                    <template v-slot:item="{ item }">
                                        {{ item.cod_rota }} - {{ item.nome_rota }} ({{ item.descricao_tipo_rota }} - {{
                                        item.descricao_sentido }})
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-datetime-picker :label="$t('datetime.startDateAndHour')" v-model="datetimeInicioRota"
                                    :time-picker-props="timeProps" :date-picker-props="rotaVigenciaDatePickerPropsInicio"
                                    :text-field-props="textFieldProps" time-format="HH:mm" date-format="dd/MM/yyyy"
                                    :clear-text="$t('button.clear')">
                                    <template slot="dateIcon">
                                        <v-icon>mdi-calendar</v-icon>
                                    </template>
                                    <template slot="timeIcon">
                                        <v-icon>mdi-clock</v-icon>
                                    </template>
                                </v-datetime-picker>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-datetime-picker :label="$t('datetime.endDateAndHour')" v-model="datetimeFimRota"
                                    :time-picker-props="timeProps" :date-picker-props="rotaVigenciaDatePickerPropsFim"
                                    :text-field-props="textFieldProps" time-format="HH:mm" date-format="dd/MM/yyyy"
                                    :clear-text="$t('button.clear')">
                                    <template slot="dateIcon">
                                        <v-icon>mdi-calendar</v-icon>
                                    </template>
                                    <template slot="timeIcon">
                                        <v-icon>mdi-clock</v-icon>
                                    </template>
                                </v-datetime-picker>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialogRotaVigencia = false">
                        {{ $t('button.cancel') }}
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="saveRotaVigencia">
                        {{ $t('button.save') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog para Adicionar/Editar Cerca Vigência -->
        <v-dialog v-model="dialogCercaVigencia" max-width="900px" persistent>
            <v-card>
                <v-card-title>
                    <span class="text-h5">
                        {{ isEditingCercaVigencia ? $t('CRUDVigencia.fences.editAlternative') : $t('CRUDVigencia.fences.addAlternative') }} {{ $t('CRUDVigencia.fences.alternative') }}
                    </span>
                </v-card-title>

                <v-card-text>
                    <v-container>
                        <!-- Dates Section -->
                        <v-row>
                            <v-col cols="12">
                                <h4 class="mb-3">{{ $t('CRUDVigencia.fences.validityPeriod') }}</h4>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-datetime-picker :label="$t('datetime.startDateAndHour')" v-model="datetimeInicioCerca"
                                    :time-picker-props="timeProps" :date-picker-props="cercaVigenciaDatePickerPropsInicio"
                                    :text-field-props="textFieldProps" time-format="HH:mm" date-format="dd/MM/yyyy"
                                    :clear-text="$t('button.clear')">
                                    <template slot="dateIcon">
                                        <v-icon>mdi-calendar</v-icon>
                                    </template>
                                    <template slot="timeIcon">
                                        <v-icon>mdi-clock</v-icon>
                                    </template>
                                </v-datetime-picker>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-datetime-picker :label="$t('datetime.endDateAndHour')" v-model="datetimeFimCerca"
                                    :time-picker-props="timeProps" :date-picker-props="cercaVigenciaDatePickerPropsFim"
                                    :text-field-props="textFieldProps" time-format="HH:mm" date-format="dd/MM/yyyy"
                                    :clear-text="$t('button.clear')">
                                    <template slot="dateIcon">
                                        <v-icon>mdi-calendar</v-icon>
                                    </template>
                                    <template slot="timeIcon">
                                        <v-icon>mdi-clock</v-icon>
                                    </template>
                                </v-datetime-picker>
                            </v-col>
                        </v-row>

                        <v-divider class="my-4"></v-divider>

                        <!-- Add Cerca Button -->
                        <v-row>
                            <v-col cols="12" class="d-flex justify-space-between align-center">
                                <h4>{{ $t('CRUDVigencia.fences.stops') }}</h4>
                                <v-btn color="primary" @click="openAddCercaDialog">
                                    <v-icon left>mdi-plus</v-icon>
                                    {{ $t('CRUDVigencia.fences.addCerca') }}
                                </v-btn>
                            </v-col>
                        </v-row>

                        <!-- Stops Table -->
                        <v-row>
                            <v-col cols="12">
                                <v-alert v-if="cercasInVigencia.length === 0" type="info" outlined>
                                    {{ $t('CRUDVigencia.fences.noCercaAdded') }}
                                </v-alert>
                                <v-simple-table v-else>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th class="text-left">{{ $t('CRUDVigencia.fences.headerdefault.order') }}</th>
                                                <th class="text-left">{{ $t('CRUDVigencia.fences.headerdefault.code') }}</th>
                                                <th class="text-left">{{ $t('CRUDVigencia.fences.headerdefault.name') }}</th>
                                                <th class="text-left">{{ $t('CRUDVigencia.fences.headerdefault.direction') }}</th>
                                                <th class="text-left">{{ $t('CRUDVigencia.fences.headerdefault.type') }}</th>
                                                <th class="text-center">{{ $t('CRUDVigencia.fences.headerdefault.actions') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(cerca, index) in cercasInVigencia" :key="cerca._tempId">
                                                <td>
                                                    <div class="d-flex align-center">
                                                        <span class="mr-2">{{ cerca.ordem_parada }}</span>
                                                        <div class="d-flex flex-column">
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-btn icon x-small 
                                                                        @click="moveCercaUp(cerca, index)"
                                                                        :disabled="index === 0"
                                                                        v-bind="attrs" v-on="on">
                                                                        <v-icon x-small>mdi-chevron-up</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span>{{ $t('CRUDVigencia.fences.moveUp') }}</span>
                                                            </v-tooltip>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-btn icon x-small 
                                                                        @click="moveCercaDown(cerca, index)"
                                                                        :disabled="index === cercasInVigencia.length - 1"
                                                                        v-bind="attrs" v-on="on">
                                                                        <v-icon x-small>mdi-chevron-down</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span>{{ $t('CRUDVigencia.fences.moveDown') }}</span>
                                                            </v-tooltip>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>{{ cerca.cod_cerca }}</td>
                                                <td>{{ cerca.nome_cerca }}</td>
                                                <td>{{ cerca.descricao_sentido }}</td>
                                                <td>{{ cerca.descricao_tipo_cerca }}</td>
                                                <td class="text-center">
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn icon small color="blue" class="mr-2"
                                                                @click.stop="editCercaInVigencia(cerca, index)"
                                                                v-bind="attrs" v-on="on">
                                                                <v-icon small>mdi-pencil</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>{{ $t('CRUDVigencia.fences.editCerca') }}</span>
                                                    </v-tooltip>
                                                    <v-tooltip bottom v-if="cerca.descricao_tipo_cerca !== 'Ponto Inicial' && cerca.descricao_tipo_cerca !== 'Ponto Final'">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn icon small color="red" 
                                                                @click.stop="deleteCercaFromVigencia(index)"
                                                                v-bind="attrs" v-on="on">
                                                                <v-icon small>mdi-delete</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>{{ $t('CRUDVigencia.fences.removeCerca') }}</span>
                                                    </v-tooltip>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeCercaVigenciaDialog">
                        {{ $t('button.cancel') }}
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="saveCercaVigencia">
                        {{ $t('button.save') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog para Adicionar Cerca dentro da Vigência -->
        <v-dialog v-model="dialogAddCerca" max-width="600px" persistent>
            <v-card>
                <v-card-title>
                    <span class="text-h5">
                        {{ newCercaToAdd.editingIndex !== undefined ? $t('CRUDVigencia.fences.editCerca') : $t('CRUDVigencia.fences.addCerca') }} {{ $tc('CRUDVigencia.fences.title', 1) }}
                    </span>
                </v-card-title>

                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-select v-model="newCercaToAdd.id_cerca" :items="allCercas"
                                    item-text="nome_cerca" item-value="id_cerca" :label="$t('CRUDVigencia.fences.selectCerca')" required
                                    autofocus>
                                    <template v-slot:selection="{ item }">
                                        {{ item.cod_cerca }} - {{ item.nome_cerca }}
                                    </template>
                                    <template v-slot:item="{ item }">
                                        <v-list-item-content>
                                            <v-list-item-title>{{ item.nome_cerca }}</v-list-item-title>
                                            <v-list-item-subtitle>{{ $t('CRUDVigencia.fences.codeAndType', { code: item.cod_cerca, type: item.descricao_tipo_cerca }) }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-select 
                                    v-model="newCercaToAdd.id_tipo_cerca" 
                                    :items="allTiposCerca"
                                    item-text="descricao_tipo_cerca" 
                                    item-value="id_tipo_cerca" 
                                    :label="$t('CRUDVigencia.fences.typeOfCerca')" 
                                    required
                                    :hint="$t('CRUDVigencia.fences.typeOfCercaHint')"
                                    persistent-hint>
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-select 
                                    v-model="newCercaToAdd.id_sentido" 
                                    :items="allSentidos"
                                    item-text="descricao_sentido" 
                                    item-value="id_sentido" 
                                    :label="$t('CRUDVigencia.fences.direction')" 
                                    required
                                    :hint="$t('CRUDVigencia.fences.directionHint')"
                                    persistent-hint>
                                </v-select>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialogAddCerca = false">
                        {{ $t('button.cancel') }}
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="addCercaToVigencia">
                        {{ newCercaToAdd.editingIndex !== undefined ? $t('button.save') : $t('button.add') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

import apiController from "@/utils/apiController";
import MerusDataTable from "../Tables/MerusDataTable.vue";
import EventBus from "@/utils/eventBus";
import CadastroToolbar from "../Toolbars/CadastroToolbar.vue"
import translateDbField from "@/utils/translateDbField";
import serverTableMixin from "@/mixins/serverTableMixin";
import { buildRequestParams, computePageState, initSortFromDefault } from "@/utils/serverTablePagination";

export default {
    name: 'CRUDVigencia',
    mixins: [serverTableMixin],
    components: {
        MerusDataTable,
        CadastroToolbar
    },
    data: () => ({
    headers: [],
    stopsInVigenciaHeaders: [],
    cercasVigenciaHeaders: [],
    cercasHeadersExpanded: [],
    rotasVigenciaHeaders: [],
    rotasHeadersWithActions: [],
        tab: 0,
        linhas: [],
        mostrarInativos: false,
        // Paginação server-side da grade de linhas (getalllinhas em modo total=true).
        loadingtable: true,
        totalLinhas: 0,
        pageNumber: 1,
        numberOfRows: 20,
        itemsPerPageLastOption: 1000,
        lastItemsPerPageBeforeTodos: null,
        serverSortBy: [],
        serverSortDesc: [],
        searchFilters: {},
        rotas: [],
        cercas: [],
        rotasVigencia: [],
        cercasVigencia: [],
        allRotas: [],
        allCercas: [],
        allTiposCerca: [],
        allSentidos: [],
        token: null,
        selectedLinha: null,
        selectedRotaForVigencia: null,
        selectedVigencia: null,
        dialog: false,
        dialogRotaVigencia: false,
        dialogCercaVigencia: false,
        dialogAddCerca: false,
        editedRotaVigencia: {},
        editedCercaVigencia: {},
        newCercaToAdd: {},
        isEditingRotaVigencia: false,
        isEditingCercaVigencia: false,
        cercasInVigencia: [], // Temporary list of cercas being configured for this vigencia
        datetimeInicioRota: null,
        datetimeFimRota: null,
        datetimeInicioCerca: null,
        datetimeFimCerca: null,
        timeProps: {
            useSeconds: true,
        },
    }),
    computed: {
        sentidoOptions() {
            return [
            { text: this.$t('CRUDVigencia.fences.directionIda'), value: 1 },
            { text: this.$t('CRUDVigencia.fences.directionVolta'), value: 2 }
        ];
        },
        textFieldProps() {
            return {
            prependInnerIcon: "mdi-calendar",
            rules: [(v) => !!v || this.$t('contract.messages.selectDate')],
            };
        },
        rotaVigenciaDatePickerPropsInicio() {
            const props = { locale: 'pt-BR' };
            const max = this.localYmdForVDatePicker(this.datetimeFimRota);
            if (max) props.max = max;
            return props;
        },
        rotaVigenciaDatePickerPropsFim() {
            const props = { locale: 'pt-BR' };
            const min = this.localYmdForVDatePicker(this.datetimeInicioRota);
            if (min) props.min = min;
            return props;
        },
        cercaVigenciaDatePickerPropsInicio() {
            const props = { locale: 'pt-BR' };
            const max = this.localYmdForVDatePicker(this.datetimeFimCerca);
            if (max) props.max = max;
            return props;
        },
        cercaVigenciaDatePickerPropsFim() {
            const props = { locale: 'pt-BR' };
            const min = this.localYmdForVDatePicker(this.datetimeInicioCerca);
            if (min) props.min = min;
            return props;
        },
        /** Ordenação inicial enviada ao servidor (mesma da listagem legada: por nome da linha). */
        defaultSort() {
            return [
                { value: 'nome_linha', options: { text: this.$t('system.labels.increasing'), value: 1 } },
            ];
        },
        hasPosicaoPreenchida() {
            return !!(this.editedCercaVigencia.id_sentido || this.editedCercaVigencia.ordem_parada);
        },
        filteredRotasVigencia() {
            if (!this.selectedRotaForVigencia) {
                return [];
            }
            return this.rotasVigencia.filter(rv =>
                rv.id_rota_substituida === this.selectedRotaForVigencia.id_rota
            );
        },
        uniqueCercasSentidos() {
            // Group cercas by sentido and get unique sentidos with count
            // Map sentidos -1, 3, 4, 7, 8 to sentido 1 (IDA) and sentido 2 (VOLTA)
            // Note: -1, 7, 8 (Ida e Volta) appear in BOTH IDA and VOLTA
            
            // Safety check: ensure cercas is an array
            if (!Array.isArray(this.cercas)) {
                return [];
            }
            
            const sentidosMap = new Map();
            this.cercas.forEach(cerca => {
                let keys = []; // Can belong to multiple sentidos
                let descricao = cerca.descricao_sentido;
                
                // Special cases: -1, 7, 8 (Ida e Volta) belong to BOTH IDA and VOLTA
                if ([-1, 7, 8].includes(cerca.id_sentido)) {
                    keys = [1, 2]; // Map to both IDA and VOLTA only
                }
                // Map specific sentidos to sentido 1 (IDA)
                else if ([3, 4].includes(cerca.id_sentido)) {
                    keys = [1];
                    descricao = this.$t('CRUDVigencia.fences.directionIda');
                }
                // Map specific sentidos to sentido 2 (VOLTA)
                else if ([5, 6].includes(cerca.id_sentido)) {
                    keys = [2];
                    descricao = this.$t('CRUDVigencia.fences.directionVolta');
                }
                // Default: keep original sentido
                else {
                    keys = [cerca.id_sentido];
                }
                
                // Add count to all applicable sentidos
                keys.forEach(key => {
                    if (!sentidosMap.has(key)) {
                        sentidosMap.set(key, {
                            id_sentido: key,
                            descricao_sentido: key === 1 ? this.$t('CRUDVigencia.fences.directionIda') : (key === 2 ? this.$t('CRUDVigencia.fences.directionVolta') : descricao),
                            count: 0
                        });
                    }
                    sentidosMap.get(key).count++;
                });
            });
            
            // Filter out sentidos 7 and 8 (Ida e Volta) from the final list
            return Array.from(sentidosMap.values()).filter(s => ![7, 8].includes(s.id_sentido));
        },
        filteredCercasBySentido() {
            if (!this.selectedSentidoForCercas) {
                return [];
            }
            // If sentido 1 (IDA) is selected, include cercas with sentidos -1, 3, 4, 7, 8
            if (this.selectedSentidoForCercas.id_sentido === 1) {
                return this.cercas.filter(cerca =>
                    [1, -1, 3, 4, 7, 8].includes(cerca.id_sentido)
                );
            }
            // If sentido 2 (VOLTA) is selected, include cercas with sentidos -1, 5, 6, 7, 8
            if (this.selectedSentidoForCercas.id_sentido === 2) {
                return this.cercas.filter(cerca =>
                    [2, -1, 5, 6, 7, 8].includes(cerca.id_sentido)
                );
            }
            return this.cercas.filter(cerca =>
                cerca.id_sentido === this.selectedSentidoForCercas.id_sentido
            );
        },
    rotasHeaders() {
            return [
                { text: this.$t('CRUDVigencia.headers.code'), value: 'cod_rota' },
                { text: this.$t('CRUDVigencia.headers.name'), value: 'nome_rota' },
                { text: this.$t('CRUDVigencia.headersroutes.type'), value: 'descricao_tipo_rota' },
                { text: this.$t('CRUDVigencia.headersroutes.direction'), value: 'descricao_sentido' },
                { text: this.$t('CRUDVigencia.headersroutes.distance'), value: 'distancia' }]
        },
    cercasSentidosHeaders() {
            return [
                { text: this.$t('CRUDVigencia.headersroutes.direction'), value: 'descricao_sentido' },
                { text: this.$t('CRUDVigencia.fencesDirectionHeaders.Quantity'), value: 'count' },
                { text: this.$t('CRUDVigencia.headers.actions'), value: 'actions', sortable: false, align: 'center' }]
        },
        cercasHeaders() {
            return [
                { text: this.$t('CRUDVigencia.headers.code'), value: 'cod_cerca' },
                { text: this.$t('CRUDVigencia.headers.name'), value: 'nome_cerca' },
                { text: this.$t('CRUDVigencia.headersroutes.type'), value: 'descricao_tipo_cerca' },
                { text: this.$t('CRUDVigencia.headersroutes.direction'), value: 'descricao_sentido' },
                { text: this.$t('CRUDVigencia.fencesHeaders.order'), value: 'ordem_parada' }]
        },
    cercasVigenciaGrouped() {
            // Group cercas by id_associacao and count the stops
            // Filter out cercas where padrao = 1
            if (!Array.isArray(this.cercasVigencia) || this.cercasVigencia.length === 0) {
                return []
            }
            
            const grouped = {}
            this.cercasVigencia.forEach(cerca => {
                // Skip cercas where padrao = 1
                if (cerca.padrao === 1) {
                    return
                }
                
                const id = cerca.id_associacao
                if (!grouped[id]) {
                    grouped[id] = {
                        id_associacao: cerca.id_associacao,
                        id_linha: cerca.id_linha,
                        id_sentido: cerca.id_sentido,
                        data_inicio: cerca.data_inicio,
                        data_fim: cerca.data_fim,
                        hora_inicio: cerca.hora_inicio,
                        hora_fim: cerca.hora_fim,
                        padrao: cerca.padrao,
                        ativa: cerca.ativa,
                        quantidade_paradas: 0
                    }
                }
                grouped[id].quantidade_paradas++
            })
            
            return Object.values(grouped)
        },
    stopsInSelectedVigencia() {
            if (!this.selectedVigencia) {
                return []
            }
            // Filter cercas that belong to the selected vigência (by id_associacao)
            return this.cercasVigencia.filter(cerca => 
                cerca.id_associacao === this.selectedVigencia.id_associacao
            )
        }
    },
    watch: {
        '$i18n.locale'() {
            this.populaTabelas();
        },
        // showInactives é resolvido no servidor: volta para a primeira página ao alternar.
        mostrarInativos() {
            this.pageNumber = 1;
            this.serverTableLoad({ page: 1 });
        },
        datetimeInicioRota(val) {
            this.$nextTick(() => {
                if (val && this.datetimeFimRota && this.datetimeFimRota < val) {
                    this.datetimeFimRota = new Date(val.getTime());
                }
            });
        },
        datetimeFimRota(val) {
            if (val && this.datetimeInicioRota && val < this.datetimeInicioRota) {
                this.datetimeFimRota = new Date(this.datetimeInicioRota.getTime());
            }
        },
        datetimeInicioCerca(val) {
            this.$nextTick(() => {
                if (val && this.datetimeFimCerca && this.datetimeFimCerca < val) {
                    this.datetimeFimCerca = new Date(val.getTime());
                }
            });
        },
        datetimeFimCerca(val) {
            if (val && this.datetimeInicioCerca && val < this.datetimeInicioCerca) {
                this.datetimeFimCerca = new Date(this.datetimeInicioCerca.getTime());
            }
        },
    },
    methods: {

        localYmdForVDatePicker(value) {
            if (!value) return null;
            const d = value instanceof Date ? value : new Date(value);
            if (Number.isNaN(d.getTime())) return null;
            const y = d.getFullYear();
            const m = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${y}-${m}-${day}`;
        },
        selectRotaForVigencia(rota) {
            this.selectedRotaForVigencia = rota;
        },
        selectVigenciaToViewStops(vigencia) {
            this.selectedVigencia = vigencia;
        },
        // Helper to split datetime into date and time for database
        splitDateTime(datetime) {
            if (!datetime) return { date: null, time: null }
            const dt = new Date(datetime)
            const date = dt.toISOString().split('T')[0] // YYYY-MM-DD
            const hours = String(dt.getHours()).padStart(2, '0')
            const minutes = String(dt.getMinutes()).padStart(2, '0')
            const time = `${hours}:${minutes}:00` // HH:mm:ss
            return { date, time }
        },
        // Helper to combine date and time into datetime
        combineDateTime(date, time) {
            if (!date) return null
            if (!time) {
                // If no time, return date at 00:00
                return new Date(date + 'T00:00:00')
            }
            // Combine date and time
            const timeOnly = time.substring(0, 5) // HH:mm
            return new Date(date + 'T' + timeOnly + ':00')
        },
        formatDate(date) {
            if (!date) return ''
            const d = new Date(date)
            const day = String(d.getDate()).padStart(2, '0')
            const month = String(d.getMonth() + 1).padStart(2, '0')
            const year = d.getFullYear()
            return `${day}/${month}/${year}`
        },
        /** Recarrega a página atual da grade (mantém filtros e ordenação vigentes). */
        getLinhas() {
            this.serverTableLoad()
        },
        /** Carrega uma página de linhas do servidor (getalllinhas em modo paginado). */
        serverTableLoad(options) {
            if (this.serverSortBy.length === 0 && this.defaultSort && this.defaultSort.length > 0) {
                const { serverSortBy, serverSortDesc } = initSortFromDefault(this.defaultSort)
                this.serverSortBy = serverSortBy
                this.serverSortDesc = serverSortDesc
            }
            const state = {
                pageNumber: this.pageNumber,
                numberOfRows: this.numberOfRows,
                serverSortBy: this.serverSortBy,
                serverSortDesc: this.serverSortDesc,
                searchFilters: this.searchFilters,
                lastItemsPerPageBeforeTodos: this.lastItemsPerPageBeforeTodos,
                total: this.totalLinhas,
            }
            const { params, page, rowsPerPage, sortByArr, sortDescArr } = buildRequestParams(options, state)
            params.showInactives = this.mostrarInativos ? 'true' : 'false'
            this.loadingtable = true
            apiController.request(apiController.endpoints.getallLinhas, {
                data: params,
                onSuccess: response => {
                    const data = response.data
                    const totalNum = data && data.total != null && data.total !== '' ? Number(data.total) : NaN
                    if (data && !Number.isNaN(totalNum) && Array.isArray(data.items)) {
                        this.linhas = data.items
                        const updates = computePageState(
                            { items: data.items, total: totalNum },
                            { page, rowsPerPage, sortByArr, sortDescArr },
                            state,
                            this.itemsPerPageLastOption
                        )
                        this.totalLinhas = updates.total
                        this.pageNumber = updates.pageNumber
                        this.numberOfRows = updates.numberOfRows
                        this.lastItemsPerPageBeforeTodos = updates.lastItemsPerPageBeforeTodos
                        this.serverSortBy = updates.serverSortBy
                        this.serverSortDesc = updates.serverSortDesc
                    } else {
                        this.linhas = Array.isArray(data) ? data : []
                        this.totalLinhas = this.linhas.length
                    }
                    this.loadingtable = false
                },
                onError: () => {
                    this.linhas = []
                    this.loadingtable = false
                },
            })
        },
        viewLinha(linha) {
            this.selectedLinha = linha
            this.selectedRotaForVigencia = null
            this.tab = 0
            this.rotas = []
            this.cercas = []
            this.rotasVigencia = []
            this.cercasVigencia = []
            this.dialog = true
            this.getRotas(linha.id_linha)
            this.getCercas(linha.id_linha)
            this.getRotasVigencia(linha.id_linha)
            this.getCercasVigencia(linha.id_linha)
            this.getAllRotas()
            this.getAllCercas()
            this.getAllTiposCerca()
            this.getAllSentidos()
        },
        fechaDialogo() {
            this.dialog = false
            this.selectedLinha = null
            this.selectedVigencia = null
            this.rotas = []
            this.cercas = []
            this.rotasVigencia = []
            this.cercasVigencia = []
            this.tab = 0
        },
        getRotas(id_linha) {
            // Get routes marked as padrao for this line
            apiController.request(apiController.endpoints.getRotaspadraoporlinha, {
                data: [id_linha],
                onSuccess: response => {
                    this.rotas = Array.isArray(response.data) ? response.data : []
                    console.log('Rotas Padrão:', this.rotas)
                },
                onError: () => {
                    this.rotas = []
                },
            })
        },
        getCercas(id_linha) {
            apiController.request(apiController.endpoints.getCercaspadraoporlinha, {
                data: [id_linha],
                onSuccess: response => {
                    // Ensure response.data is an array
                    this.cercas = Array.isArray(response.data) ? response.data : []
                    console.log('Cercas Padrão:', this.cercas)
                },
                onError: () => {
                    this.cercas = [] // Set empty array on error
                },
            })
        },
        populaTabelas() {
            this.getLinhas()
        },
        getRotasVigencia(id_linha) {
            apiController.request(apiController.endpoints.getRotasvigenciaporlinha, {
                data: [id_linha],
                onSuccess: response => {
                    this.rotasVigencia = Array.isArray(response.data) ? response.data : []
                    console.log('Rotas Vigência:', this.rotasVigencia)
                },
                onError: () => {
                    this.rotasVigencia = []
                },
            })
        },
        getAllRotas() {
            apiController.request(apiController.endpoints.getallRotasativas, {
                onSuccess: response => {
                    this.allRotas = Array.isArray(response.data) ? response.data : []
                },
                onError: () => {
                    this.allRotas = []
                },
            })
        },
        getAllCercas() {
            apiController.request(apiController.endpoints.getallCercasativas, {
                onSuccess: response => {
                    this.allCercas = Array.isArray(response.data) ? response.data : []
                },
                onError: () => {
                    this.allCercas = []
                },
            })
        },
        getAllTiposCerca() {
            apiController.request(apiController.endpoints.getTiposcerca, {
                onSuccess: response => {
                    this.allTiposCerca = Array.isArray(response.data) ? response.data : []
                    this.allTiposCerca = this.allTiposCerca.map(tipoCerca => {
                        const translated = translateDbField(
                            tipoCerca.translation_key,
                            tipoCerca.descricao_tipo_cerca
                        );
                        return {
                            ...tipoCerca,
                            descricao_tipo_cerca: translated
                        };
                    });
                    console.log('Tipos de cerca carregados:', this.allTiposCerca)
                },
                onError: () => {
                    this.allTiposCerca = []
                },
            })
        },
        getAllSentidos() {
            apiController.request(apiController.endpoints.getallSentidos, {
                onSuccess: response => {
                    this.allSentidos = response.data.map((sentido) => {
                        const translated = translateDbField(
                            sentido.translation_key,
                            sentido.descricao_sentido
                        );
                        return {
                            ...sentido,
                            descricao_sentido: translated
                        };
                    });
                },
                onError: () => {
                    this.allSentidos = []
                },
            })
        },
        openAddRotaVigenciaDialog() {
            if (!this.selectedLinha) {
                EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.error.noLineSelected'), tipo: 'error' })
                return
            }
            if (!this.selectedRotaForVigencia) {
                EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.warning.noRouteSelected'), tipo: 'warning' })
                return
            }
            this.isEditingRotaVigencia = false
            this.datetimeInicioRota = null
            this.datetimeFimRota = null
            this.editedRotaVigencia = {
                id_rota: null,
                id_rota_substituida: this.selectedRotaForVigencia.id_rota,
                id_linha: this.selectedLinha.id_linha,
                data_inicio: '',
                data_final: '',
                hora_inicio: '',
                hora_final: '',
                padrao: 0,
                ativo: 1
            }
            this.dialogRotaVigencia = true
        },
        editRotaVigencia(item) {
            this.isEditingRotaVigencia = true
            this.editedRotaVigencia = { ...item }

            // Format dates to YYYY-MM-DD
            if (item.data_inicio) {
                this.editedRotaVigencia.data_inicio = item.data_inicio.split('T')[0]
            }
            if (item.data_final) {
                this.editedRotaVigencia.data_final = item.data_final.split('T')[0]
            }

            // Combine date and time into datetime for picker
            this.datetimeInicioRota = this.combineDateTime(
                this.editedRotaVigencia.data_inicio,
                this.editedRotaVigencia.hora_inicio
            )
            this.datetimeFimRota = this.combineDateTime(
                this.editedRotaVigencia.data_final,
                this.editedRotaVigencia.hora_final
            )

            this.dialogRotaVigencia = true
        },
        deleteRotaVigencia(item) {
            
                // Deactivate the route by setting ativo = 0
            const dataToUpdate = {
                id_rota: item.id_rota,
                id_rota_substituida: item.id_rota_substituida,
                id_linha: item.id_linha,
                data_inicio: item.data_inicio ? item.data_inicio.split('T')[0] : null,
                data_final: item.data_final ? item.data_final.split('T')[0] : null,
                hora_inicio: item.hora_inicio,
                hora_final: item.hora_final,
                padrao: item.padrao || 0,
                ativo: 0  // Deactivate
            }

            apiController.request(apiController.endpoints.updateRotavigencia, {
                params: { id: item.id_associacao },
                data: dataToUpdate,
                onSuccess: response => {
                    if (!response.data.erro) {
                        EventBus.$emit('show-alert', { mensagem: 'Rota alternativa desativada com sucesso', tipo: 'success' })
                        this.getRotasVigencia(this.selectedLinha.id_linha)
                    } else {
                        EventBus.$emit('show-alert', { mensagem: 'Erro ao desativar: ' + response.data.mensagem, tipo: 'error' })
                    }
                },
            })
        },

        saveRotaVigencia() {
            // Validate required fields
            if (!this.editedRotaVigencia.id_rota) {
                EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.warning.noRouteAlternativeSelected'), tipo: 'warning' })
                return
            }
            if (!this.editedRotaVigencia.id_rota_substituida) {
                EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.warning.noRouteSubstitutedSelected'), tipo: 'warning' })
                return
            }
            if (!this.datetimeInicioRota) {
                EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.warning.noStartDateSelected'), tipo: 'warning' })
                return
            }
            if (
                this.datetimeFimRota &&
                this.datetimeInicioRota &&
                new Date(this.datetimeFimRota) <= new Date(this.datetimeInicioRota)
            ) {
                EventBus.$emit('show-alert', { mensagem: this.$t('datetime.startDateAfterEndDate'), tipo: 'warning' });
                return;
            }

            // Split datetime into date and time for database
            const inicio = this.splitDateTime(this.datetimeInicioRota)
            const fim = this.splitDateTime(this.datetimeFimRota)

            const dataToSend = {
                ...this.editedRotaVigencia,
                data_inicio: inicio.date,
                hora_inicio: inicio.time,
                data_final: fim.date,
                hora_final: fim.time,
                id_tipo_rota: this.selectedRotaForVigencia ? this.selectedRotaForVigencia.id_tipo_rota : null,
                id_sentido: this.selectedRotaForVigencia ? this.selectedRotaForVigencia.id_sentido : null
            }

            if (this.isEditingRotaVigencia) {
                apiController.request(apiController.endpoints.updateRotavigencia, {
                    params: { id: this.editedRotaVigencia.id_associacao },
                    data: dataToSend,
                    onSuccess: response => {
                        if (!response.data.erro) {
                            EventBus.$emit('show-alert', { mensagem: response.data.mensagem, tipo: 'success' })
                            this.dialogRotaVigencia = false
                            this.getRotasVigencia(this.selectedLinha.id_linha)
                        } else {
                            EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.error.updateError') + response.data.mensagem, tipo: 'error' })
                        }
                    },
                })
            } else {
                // Insert the rota vigencia (backend will handle linhas_rotas insertion automatically)
                apiController.request(apiController.endpoints.insertRotavigencia, {
                    data: dataToSend,
                    onSuccess: response => {
                        if (!response.data.erro) {
                            EventBus.$emit('show-alert', { mensagem: response.data.mensagem, tipo: 'success' })
                            this.dialogRotaVigencia = false
                            this.getRotasVigencia(this.selectedLinha.id_linha)
                        } else {
                            EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.error.insertError') + response.data.mensagem, tipo: 'error' })
                        }
                    },
                })
            }
        },
        getCercasVigencia(id_linha) {
            apiController.request(apiController.endpoints.getCercasvigenciaporlinha, {
                data: [id_linha],
                onSuccess: response => {
                    this.cercasVigencia = Array.isArray(response.data) ? response.data : []
                },
                onError: () => {
                    this.cercasVigencia = []
                },
            })
        },
        openAddCercaVigenciaDialog() {
            if (!this.selectedLinha) {
                EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.error.noCercaSelected'), tipo: 'error' })
                return
            }
            
            this.isEditingCercaVigencia = false
            this.datetimeInicioCerca = null
            this.datetimeFimCerca = null
            
            // Load default cercas from cercas_vigencia (padrao = 1)
            // These will be pre-loaded with the sentido from cercas_ordem
            apiController.request(apiController.endpoints.getCercaspadraoporlinha, {
                data: [this.selectedLinha.id_linha],
                onSuccess: response => {
                    const allDefaultCercas = Array.isArray(response.data) ? response.data : []

                    // Map to add temporary IDs for Vue reactivity
                    const cercas = allDefaultCercas.map((cerca, idx) => ({
                        ...cerca,
                        _tempId: Date.now() + idx
                    }))

                    // Reorder based on type: Ponto Inicial (0), regular stops (1+), Ponto Final (end)
                    this.cercasInVigencia = this.reorderCercasByType(cercas)
                },
                onError: () => {
                    this.cercasInVigencia = []
                },
            })
            
            this.editedCercaVigencia = {
                id_cerca: null,
                id_cerca_substituida: null,
                id_linha: this.selectedLinha.id_linha,
                ordem_parada: null,
                id_sentido: null,
                data_inicio: '',
                data_fim: '',
                hora_inicio: '',
                hora_fim: '',
                padrao: 0,
                ativa: 0
            }
            this.dialogCercaVigencia = true
        },
        editCercaVigencia(item) {
            this.isEditingCercaVigencia = true
            this.editedCercaVigencia = { ...item }

            // Format dates to YYYY-MM-DD
            if (item.data_inicio) {
                this.editedCercaVigencia.data_inicio = item.data_inicio.split('T')[0]
            }
            if (item.data_fim) {
                this.editedCercaVigencia.data_fim = item.data_fim.split('T')[0]
            }

            // Combine date and time into datetime for picker
            this.datetimeInicioCerca = this.combineDateTime(
                this.editedCercaVigencia.data_inicio,
                this.editedCercaVigencia.hora_inicio
            )
            this.datetimeFimCerca = this.combineDateTime(
                this.editedCercaVigencia.data_fim,
                this.editedCercaVigencia.hora_fim
            )

            // Load all cercas for this vigencia
            apiController.request(apiController.endpoints.getCercavigenciaporid, {
                params: { id: item.id_associacao },
                onSuccess: response => {
                    const cercas = Array.isArray(response.data) ? response.data : []

                    // Map and add temp IDs
                    this.cercasInVigencia = cercas.map((cerca, idx) => ({
                        ...cerca,
                        _tempId: Date.now() + idx
                    }))

                    // Reorder based on type
                    this.cercasInVigencia = this.reorderCercasByType(this.cercasInVigencia)
                },
                onError: () => {
                    this.cercasInVigencia = []
                },
            })

            this.dialogCercaVigencia = true
        },
        deleteCercaVigencia(item) {
            // First, delete from cercas_ordem
            apiController.request(apiController.endpoints.deleteCercaordem, {
                params: { id_ordem: item.id_associacao },
                onSuccess: ordemResponse => {
                    if (!ordemResponse.data.erro) {

                        // Then, delete from cercas_vigencia
                        apiController.request(apiController.endpoints.deleteCercavigencia, {
                            params: { id: item.id_associacao },
                            onSuccess: vigenciaResponse => {
                                if (!vigenciaResponse.data.erro) {
                                    EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.success.cercaVigenciaDeleted'), tipo: 'success' })

                                    // Clear selection if this was the selected vigencia
                                    if (this.selectedVigencia && this.selectedVigencia.id_associacao === item.id_associacao) {
                                        this.selectedVigencia = null
                                    }

                                    // Refresh the list
                                    this.getCercasVigencia(this.selectedLinha.id_linha)
                                } else {
                                    EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.error.deleteErrorCercaVigencia') + vigenciaResponse.data.mensagem, tipo: 'error' })
                                }
                            },
                        })
                    } else {
                        EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.error.deleteErrorCercaOrdem') + ordemResponse.data.mensagem, tipo: 'error' })
                    }
                },
            })
        },
        onCercaSubstituidaChange() {
            // When selecting a cerca to substitute, clear position fields
            if (this.editedCercaVigencia.id_cerca_substituida) {
                this.editedCercaVigencia.id_sentido = null;
                this.editedCercaVigencia.ordem_parada = null;
            }
        },
        onPosicaoChange() {
            // When filling position fields, clear substitution field
            if (this.editedCercaVigencia.id_sentido || this.editedCercaVigencia.ordem_parada) {
                this.editedCercaVigencia.id_cerca_substituida = null;
            }
        },
        reorderCercasByType(cercas) {
            // Separate cercas by type
            const pontoInicial = cercas.filter(c => c.descricao_tipo_cerca === "Ponto Inicial");
            const pontoFinal = cercas.filter(c => c.descricao_tipo_cerca === "Ponto Final");
            const regulares = cercas.filter(c => 
                c.descricao_tipo_cerca !== "Ponto Inicial" && 
                c.descricao_tipo_cerca !== "Ponto Final"
            );
            
            // Combine: Ponto Inicial first, then regular stops, then Ponto Final
            const ordered = [...pontoInicial, ...regulares, ...pontoFinal];
            
            // Assign ordem_parada: Ponto Inicial gets 0, others get sequential numbers
            return ordered.map((cerca, idx) => {
                let ordemParada;
                if (cerca.descricao_tipo_cerca === "Ponto Inicial") {
                    ordemParada = 0;
                } else {
                    ordemParada = idx;
                }
                return {
                    ...cerca,
                    ordem_parada: ordemParada
                };
            });
        },
        openAddCercaDialog() {
            // Default to "Ponto de Parada" (tipo_cerca = 1) and default sentido from first cerca in vigencia
            const defaultTipo = this.allTiposCerca.find(t => t.descricao_tipo_cerca === "Ponto de Parada");
            const defaultSentido = this.cercasInVigencia.length > 0 ? this.cercasInVigencia[0].id_sentido : 1;
            
            this.newCercaToAdd = {
                id_cerca: null,
                id_tipo_cerca: defaultTipo ? defaultTipo.id_tipo_cerca : null,
                id_sentido: defaultSentido
            };
            this.dialogAddCerca = true;
        },
        addCercaToVigencia() {
            // Validate required fields
            if (!this.newCercaToAdd.id_cerca) {
                EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.warning.noCercaSelected'), tipo: 'warning' });
                return;
            }
            if (!this.newCercaToAdd.id_tipo_cerca) {
                EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.warning.noCercaTypeSelected'), tipo: 'warning' });
                return;
            }
            if (!this.newCercaToAdd.id_sentido) {
                EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.warning.noCercaDirectionSelected'), tipo: 'warning' });
                return;
            }

            // Get full cerca details
            const selectedCerca = this.allCercas.find(c => c.id_cerca === this.newCercaToAdd.id_cerca);
            if (!selectedCerca) {
                EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.error.findErrorCerca'), tipo: 'error' });
                return;
            }
            
            // Get tipo and sentido details
            const selectedTipo = this.allTiposCerca.find(t => t.id_tipo_cerca === this.newCercaToAdd.id_tipo_cerca);
            const selectedSentido = this.allSentidos.find(s => s.id_sentido === this.newCercaToAdd.id_sentido);

            // Check if editing an existing cerca
            if (this.newCercaToAdd.editingIndex !== undefined) {
                // Check if new cerca is already in the list (excluding the one being edited)
                const alreadyExists = this.cercasInVigencia.some((c, idx) => 
                    c.id_cerca === selectedCerca.id_cerca && idx !== this.newCercaToAdd.editingIndex
                );
                if (alreadyExists) {
                    EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.warning.cercaAlreadyAdded'), tipo: 'warning' });
                    return;
                }

                // Replace the cerca at the editing index
                const currentCerca = this.cercasInVigencia[this.newCercaToAdd.editingIndex];
                const currentOrdem = currentCerca.ordem_parada;
                const currentTempId = currentCerca._tempId;
                
                const newArray = [...this.cercasInVigencia];
                newArray[this.newCercaToAdd.editingIndex] = {
                    ...selectedCerca,
                    ordem_parada: currentOrdem,
                    id_sentido: this.newCercaToAdd.id_sentido,
                    descricao_sentido: selectedSentido ? selectedSentido.descricao_sentido : '',
                    id_tipo_cerca: this.newCercaToAdd.id_tipo_cerca,
                    descricao_tipo_cerca: selectedTipo ? selectedTipo.descricao_tipo_cerca : '',
                    _tempId: currentTempId // Keep the same temp ID for Vue reactivity
                };
                this.cercasInVigencia = newArray;

            } else {
                // Adding new cerca
                // Check if cerca is already in the list
                const alreadyExists = this.cercasInVigencia.some(c => c.id_cerca === selectedCerca.id_cerca);
                if (alreadyExists) {
                    EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.warning.cercaAlreadyAdded'), tipo: 'warning' });
                    return;
                }

                // Create new cerca with selected values
                const newCerca = {
                    ...selectedCerca,
                    id_sentido: this.newCercaToAdd.id_sentido,
                    descricao_sentido: selectedSentido ? selectedSentido.descricao_sentido : '',
                    id_tipo_cerca: this.newCercaToAdd.id_tipo_cerca,
                    descricao_tipo_cerca: selectedTipo ? selectedTipo.descricao_tipo_cerca : '',
                    _tempId: Date.now() + Math.random() // Unique temporary ID
                };

                // Position based on tipo
                if (selectedTipo && selectedTipo.descricao_tipo_cerca === "Ponto Inicial") {
                    // Ponto Inicial goes first
                    newCerca.ordem_parada = 0;
                    this.cercasInVigencia.unshift(newCerca);
                } else if (selectedTipo && selectedTipo.descricao_tipo_cerca === "Ponto Final") {
                    // Ponto Final goes last
                    newCerca.ordem_parada = this.cercasInVigencia.length;
                    this.cercasInVigencia.push(newCerca);
                } else {
                    // Regular stop - insert after Ponto Inicial
                    newCerca.ordem_parada = 1;
                    const pontoInicialIndex = this.cercasInVigencia.findIndex(c => 
                        c.descricao_tipo_cerca === "Ponto Inicial"
                    );
                    
                    if (pontoInicialIndex >= 0) {
                        // Insert right after Ponto Inicial
                        this.cercasInVigencia.splice(pontoInicialIndex + 1, 0, newCerca);
                    } else {
                        // No Ponto Inicial, add at beginning
                        this.cercasInVigencia.unshift(newCerca);
                    }
                }

                // Reorder all cercas to maintain proper ordem_parada
                this.cercasInVigencia = this.reorderCercasByType(this.cercasInVigencia);

            }

            this.dialogAddCerca = false;
        },
        editCercaInVigencia(cerca, index) {
            // Open dialog to select a different cerca to replace this one
            this.newCercaToAdd = {
                id_cerca: cerca.id_cerca,
                id_tipo_cerca: cerca.id_tipo_cerca,
                id_sentido: cerca.id_sentido,
                editingIndex: index
            };
            this.dialogAddCerca = true;
        },
        deleteCercaFromVigencia(index) {
            if (index < 0 || index >= this.cercasInVigencia.length) {
                return;
            }
            
            const cerca = this.cercasInVigencia[index];
            
            // Prevent deletion of Ponto Inicial and Ponto Final
            if (cerca.descricao_tipo_cerca === 'Ponto Inicial') {
                EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.warning.cannotRemoveInitialStop'), tipo: 'warning' });
                return;
            }
            if (cerca.descricao_tipo_cerca === 'Ponto Final') {
                EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.warning.cannotRemoveFinalStop'), tipo: 'warning' });
                return;
            }
            
            // Use Vue.delete or splice with $forceUpdate
            this.$delete(this.cercasInVigencia, index);
            
            // Reorder remaining items based on type
            this.cercasInVigencia = this.reorderCercasByType(this.cercasInVigencia);
            
            // Force update to ensure UI refreshes
            this.$forceUpdate();
            
        },
        moveCercaUp(cerca, index) {
            if (index === 0) return; // Already at the top
            
            // Don't move Ponto Inicial
            if (cerca.descricao_tipo_cerca === 'Ponto Inicial') {
                EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.warning.cannotMoveInitialStop'), tipo: 'warning' });
                return;
            }
            
            // Don't move past Ponto Inicial
            const previousCerca = this.cercasInVigencia[index - 1];
            if (previousCerca.descricao_tipo_cerca === 'Ponto Inicial') {
                EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.warning.cannotMoveInitialStop'), tipo: 'warning' });
                return;
            }
            
            // Create a new array with swapped positions
            const newArray = [...this.cercasInVigencia];
            const temp = newArray[index - 1];
            newArray[index - 1] = newArray[index];
            newArray[index] = temp;
            
            // Reorder based on type
            this.cercasInVigencia = this.reorderCercasByType(newArray);
            
        },
        moveCercaDown(cerca, index) {
            if (index === this.cercasInVigencia.length - 1) return; // Already at the bottom
            
            // Don't move Ponto Final
            if (cerca.descricao_tipo_cerca === 'Ponto Final') {
                EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.warning.cannotMoveFinalStop'), tipo: 'warning' });
                return;
            }
            
            // Don't move past Ponto Final
            const nextCerca = this.cercasInVigencia[index + 1];
            if (nextCerca.descricao_tipo_cerca === 'Ponto Final') {
                EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.warning.cannotMoveFinalStop'), tipo: 'warning' });
                return;
            }
            
            // Create a new array with swapped positions
            const newArray = [...this.cercasInVigencia];
            const temp = newArray[index + 1];
            newArray[index + 1] = newArray[index];
            newArray[index] = temp;
            
            // Reorder based on type
            this.cercasInVigencia = this.reorderCercasByType(newArray);
            
        },
        closeCercaVigenciaDialog() {
            // Close dialog and reset temporary data
            this.dialogCercaVigencia = false;
            this.cercasInVigencia = [];
            this.editedCercaVigencia = {};
            this.datetimeInicioCerca = null;
            this.datetimeFimCerca = null;
        },
        async saveCercaVigencia() {
            // Validate required fields
            if (this.cercasInVigencia.length === 0) {
                EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.warning.noCercaSelectedVigencia'), tipo: 'warning' })
                return
            }
            if (!this.datetimeInicioCerca) {
                EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.warning.noStartDateSelectedVigencia'), tipo: 'warning' })
                return
            }
            if (
                this.datetimeFimCerca &&
                this.datetimeInicioCerca &&
                new Date(this.datetimeFimCerca) <= new Date(this.datetimeInicioCerca)
            ) {
                EventBus.$emit('show-alert', { mensagem: this.$t('datetime.startDateAfterEndDate'), tipo: 'warning' });
                return;
            }

            // Split datetime into date and time for database
            const inicio = this.splitDateTime(this.datetimeInicioCerca)
            const fim = this.splitDateTime(this.datetimeFimCerca)

            // Get default id_sentido from first cerca (all cercas have their own sentido now)
            const default_id_sentido = this.cercasInVigencia.length > 0 ? this.cercasInVigencia[0].id_sentido : 1

            // Prepare ONE vigencia record (without id_sentido - now stored per-cerca in cercas_ordem)
            const vigenciaData = {
                id_linha: this.selectedLinha.id_linha,
                data_inicio: inicio.date,
                hora_inicio: inicio.time,
                data_fim: fim.date,
                hora_fim: fim.time,
                padrao: 0,
                ativa: 1
            }

            // Prepare cercas sequence for cercas_ordem table (now includes id_sentido and id_tipo_cerca per cerca)
            const cercasSequencia = this.cercasInVigencia.map(cerca => ({
                id_cerca: cerca.id_cerca,
                ordem_parada: cerca.ordem_parada,
                id_sentido: cerca.id_sentido || default_id_sentido,
                id_tipo_cerca: cerca.id_tipo_cerca
            }))

            if (this.isEditingCercaVigencia) {
                // Step 1: Update cercas_vigencia (dates)
                apiController.request(apiController.endpoints.updateVigenciadatas, {
                    params: { id: this.editedCercaVigencia.id_associacao },
                    data: vigenciaData,
                    onSuccess: response => {
                    if (!response.data.erro) {

                        // Step 2: Delete old cercas_ordem entries
                        apiController.request(apiController.endpoints.deleteCercaordem, {
                            params: { id_ordem: this.editedCercaVigencia.id_associacao },
                            onSuccess: deleteResponse => {
                            if (!deleteResponse.data.erro) {

                                // Step 3: Insert new cercas_ordem entries
                                let insertedCount = 0
                                let hasError = false
                                const totalInserts = cercasSequencia.length * 2 // cercas_ordem + cercas_linhas

                                for (let i = 0; i < cercasSequencia.length; i++) {
                                    const cerca = this.cercasInVigencia[i]

                                    // 3a. Insert into cercas_ordem
                                    apiController.request(apiController.endpoints.insertCercaordem, {
                                        data: {
                                            id_ordem: this.editedCercaVigencia.id_associacao,
                                            id_cerca: cerca.id_cerca,
                                            ordem_parada: cerca.ordem_parada,
                                            id_sentido: cerca.id_sentido || default_id_sentido,
                                            id_tipo_cerca: cerca.id_tipo_cerca
                                        },
                                        onSuccess: ordemResponse => {
                                        if (!ordemResponse.data.erro) {
                                            insertedCount++

                                            if (insertedCount === totalInserts && !hasError) {
                                                EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.success.cercaVigenciaUpdated'), tipo: 'success' })
                                                this.closeCercaVigenciaDialog()
                                                this.getCercasVigencia(this.selectedLinha.id_linha)
                                            }
                                        } else {
                                            hasError = true
                                            EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.error.insertErrorCercaOrdem') + ordemResponse.data.mensagem, tipo: 'error' })
                                        }
                                        },
                                        onError: () => {
                                            hasError = true
                                        },
                                    })

                                    // 3b. Insert/Update in cercas_linhas (only if id_tipo_cerca exists)
                                    if (!cerca.id_tipo_cerca) {
                                        insertedCount++
                                        if (insertedCount === totalInserts && !hasError) {
                                            EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.success.cercaVigenciaUpdated'), tipo: 'success' })
                                            this.closeCercaVigenciaDialog()
                                            this.getCercasVigencia(this.selectedLinha.id_linha)
                                        }
                                    } else {
                                        // Use the user-selected tipo_cerca and sentido from cercasInVigencia
                                        const tipoToUse = cerca.id_tipo_cerca
                                        const sentidoToUse = cerca.id_sentido || default_id_sentido

                                        apiController.request(apiController.endpoints.insertCercalinhaviavigencia, {
                                            data: {
                                                id_cerca: cerca.id_cerca,
                                                id_linha: this.selectedLinha.id_linha,
                                                id_tipo_cerca: tipoToUse,
                                                id_sentido: sentidoToUse,
                                                ordem_parada: cerca.ordem_parada
                                            },
                                            onSuccess: linhaResponse => {
                                            if (!linhaResponse.data.erro || linhaResponse.data.already_exists) {
                                                insertedCount++

                                                if (insertedCount === totalInserts && !hasError) {
                                                    EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.success.cercaVigenciaUpdated'), tipo: 'success' })
                                                    this.closeCercaVigenciaDialog()
                                                    this.getCercasVigencia(this.selectedLinha.id_linha)
                                                }
                                            } else {
                                                hasError = true
                                                EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.error.insertErrorCercaLinhas') + linhaResponse.data.mensagem, tipo: 'error' })
                                            }
                                            },
                                            onError: () => {
                                                hasError = true
                                            },
                                        })
                                    }
                                }

                                if (hasError) {
                                    EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.error.updateErrorCercaVigencia'), tipo: 'error' })
                                }
                            } else {
                                EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.error.deleteErrorCercaVigenciaOld') + deleteResponse.data.mensagem, tipo: 'error' })
                            }
                            },
                        })
                    } else {
                        EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.error.updateErrorVigencia') + response.data.mensagem, tipo: 'error' })
                    }
                    },
                })
            } else {
                // Step 1: Insert vigencia and get id_associacao
                apiController.request(apiController.endpoints.insertCercavigenciacomsequencia, {
                    data: { vigencia: vigenciaData },
                    onSuccess: response => {
                    if (!response.data.erro) {
                        const id_associacao = response.data.id_associacao

                        // Step 2: Insert each cerca into cercas_ordem and cercas_linhas using a for loop
                        let insertedCount = 0
                        let hasError = false
                        const totalInserts = cercasSequencia.length * 2 // cercas_ordem + cercas_linhas

                        for (let i = 0; i < cercasSequencia.length; i++) {
                            const cerca = this.cercasInVigencia[i]

                            // 2a. Insert into cercas_ordem
                            apiController.request(apiController.endpoints.insertCercaordem, {
                                data: {
                                    id_ordem: id_associacao,
                                    id_cerca: cerca.id_cerca,
                                    ordem_parada: cerca.ordem_parada,
                                    id_sentido: cerca.id_sentido || default_id_sentido,
                                    id_tipo_cerca: cerca.id_tipo_cerca
                                },
                                onSuccess: ordemResponse => {
                                if (!ordemResponse.data.erro) {
                                    insertedCount++

                                    // Check if all inserts are done
                                    if (insertedCount === totalInserts && !hasError) {
                                        EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.success.cercaVigenciaInserted'), tipo: 'success' })
                                        this.closeCercaVigenciaDialog()
                                        this.getCercasVigencia(this.selectedLinha.id_linha)
                                    }
                                } else {
                                    hasError = true
                                    EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.error.insertErrorCercaOrdem') + ordemResponse.data.mensagem, tipo: 'error' })
                                }
                                },
                                onError: () => {
                                    hasError = true
                                },
                            })

                            // 2b. Insert into cercas_linhas (only if id_tipo_cerca exists)
                            if (!cerca.id_tipo_cerca) {
                                insertedCount++
                                if (insertedCount === totalInserts && !hasError) {
                                    EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.success.cercaVigenciaCreated'), tipo: 'success' })
                                    this.closeCercaVigenciaDialog()
                                    this.getCercasVigencia(this.selectedLinha.id_linha)
                                }
                            } else {
                                // Use the user-selected tipo_cerca and sentido from cercasInVigencia
                                const tipoToUse = cerca.id_tipo_cerca
                                const sentidoToUse = cerca.id_sentido || default_id_sentido

                                apiController.request(apiController.endpoints.insertCercalinhaviavigencia, {
                                    data: {
                                        id_cerca: cerca.id_cerca,
                                        id_linha: this.selectedLinha.id_linha,
                                        id_tipo_cerca: tipoToUse,
                                        id_sentido: sentidoToUse,
                                        ordem_parada: cerca.ordem_parada
                                    },
                                    onSuccess: linhaResponse => {
                                    if (!linhaResponse.data.erro) {
                                        insertedCount++

                                        // Check if all inserts are done
                                        if (insertedCount === totalInserts && !hasError) {
                                            EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.success.cercaVigenciaCreated'), tipo: 'success' })
                                            this.closeCercaVigenciaDialog()
                                            this.getCercasVigencia(this.selectedLinha.id_linha)
                                        }
                                    } else {
                                        // If already exists, that's ok, just increment counter
                                        if (linhaResponse.data.already_exists) {
                                            insertedCount++

                                            if (insertedCount === totalInserts && !hasError) {
                                                EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.success.cercaVigenciaCreated'), tipo: 'success' })
                                                this.closeCercaVigenciaDialog()
                                                this.getCercasVigencia(this.selectedLinha.id_linha)
                                            }
                                        } else {
                                            hasError = true
                                            EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.error.insertErrorCercaLinhas') + linhaResponse.data.mensagem, tipo: 'error' })
                                        }
                                    }
                                    },
                                    onError: () => {
                                        hasError = true
                                    },
                                })
                            }
                        }

                        // Check if there was an error with the loop
                        if (hasError) {
                            EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.error.insertErrorCercaVigencia'), tipo: 'error' })
                        }
                    } else {
                        EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.error.insertErrorVigencia') + response.data.mensagem, tipo: 'error' })
                    }
                    },
                    onError: () => {
                        EventBus.$emit('show-alert', { mensagem: this.$t('CRUDVigencia.messages.error.insertErrorVigencia'), tipo: 'error' })
                    },
                })
            }
        }
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.populaTabelas()
    }
}
</script>
